import * as React from 'react';
import {Box} from '@mui/material';
import PayrollWizardCard from '../Dashboard/PayrollWizardCard';
import {usePayrollWorkflow} from '../../hooks/usePayrollWorkflow';
import {useAppNavigation} from '../../context/NavigationContext';

interface PayrollWorkflowStepsProps {
    /** Where the "view steps" action (mobile) goes; defaults to the Payroll page. */
    readonly onViewSteps?: () => void;
}

/**
 * Reusable, self-loading payroll workflow steps card (the same PayrollWizardCard the dashboard
 * renders). Responsive: PayrollWizardCard shows the full stepper from `md` up and a compact
 * "Step n of m" summary on phones. Renders nothing until a period is selected.
 */
export default function PayrollWorkflowSteps({onViewSteps}: Readonly<PayrollWorkflowStepsProps>): React.ReactElement | null {
    const {navigate} = useAppNavigation();
    const {steps, activeStepIndex, isComplete, statusLabel, periodLabel, hasPeriod} = usePayrollWorkflow();

    if (!hasPeriod) return null;

    return (
        <Box sx={{mb: 2, textAlign: 'left'}}>
            <PayrollWizardCard
                periodLabel={periodLabel}
                statusLabel={statusLabel}
                isComplete={isComplete}
                steps={steps}
                activeStepIndex={activeStepIndex}
                onViewSteps={onViewSteps ?? (() => navigate('Payroll'))}
            />
        </Box>
    );
}
